export default "__VITE_ASSET__gvpEa0hD__"